import * as React from 'react'

function SvgApi(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 55 55"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path stroke="#1B2736" strokeWidth={4} d="M2 2h51v51H2z" />
      <path
        d="M14.45 35H11l5.256-15h4.148l5.248 15h-3.45L18.39 23.428h-.119L14.45 35zm-.216-5.896h8.147v2.476h-8.147v-2.476zM26.856 35V20h6.006c1.155 0 2.139.217 2.951.652.813.43 1.433 1.028 1.859 1.794.431.762.647 1.64.647 2.637 0 .996-.219 1.875-.655 2.637-.436.761-1.068 1.355-1.895 1.78-.823.424-1.819.637-2.988.637h-3.829v-2.542h3.308c.62 0 1.13-.105 1.532-.315.406-.215.708-.51.906-.886.204-.38.305-.818.305-1.311 0-.498-.101-.933-.305-1.304a2.021 2.021 0 00-.907-.871c-.406-.21-.921-.315-1.546-.315h-2.17V35h-3.219zM43 20v15h-3.219V20H43z"
        fill="currentColor"
      />
    </svg>
  )
}

export default SvgApi
